import React from 'react'
import { useTheme } from '@mui/material/styles'
import HorizontalBarChart from './utils/HorizontalBarChart'
import { BarSeriesType } from '@mui/x-charts'
import { roundFloat } from '../../packages/utils/numberFormatters'
import { WarrantSubscriptionPeriod } from 'types/WarrantEntity'

export const WarrantCommitChart = ({
    isLeftAlign,
    subscriptionPeriod,
}: {
    isLeftAlign?: boolean
    subscriptionPeriod: WarrantSubscriptionPeriod
}) => {
    const theme = useTheme()
    const { commitments, guarantors } = subscriptionPeriod
    const notAssured = Math.max(0, 100 - +(commitments ?? 0) - +(guarantors ?? 0))

    const series: (Omit<BarSeriesType, 'data' | 'type'> & { data: [number]; label: string; omit?: boolean })[] = [
        {
            label: 'Teckningsåtagande',
            data: [roundFloat(commitments === null ? 0 : +commitments, 4)] as [number],
            color: theme.palette.info.main,
        },
        {
            label: 'Ej säkerställt',
            data: [roundFloat(notAssured, 4)] as [number],
            color: theme.palette.grey[200],
            omit: notAssured === 0,
        },
        {
            label: 'Garantiåtagande',
            data: [roundFloat(guarantors === null ? 0 : +guarantors, 4)] as [number],
            color: theme.palette.info.light,
        },
    ].filter((s) => !s.omit)

    return (
        <HorizontalBarChart
            isLeftAlign={isLeftAlign}
            labelValue={+(subscriptionPeriod.commitments ?? 0) + +(subscriptionPeriod.guarantors ?? 0)}
            series={series}
            size='small'
        />
    )
}
